import { tap as higherOrder } from 'rxjs/operators';
export function _do(nextOrObserver, error, complete) {
    return higherOrder(nextOrObserver, error, complete)(this);
}
//# sourceMappingURL=do.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs-compat/_esm5/operator/do.js
// module id = ./node_modules/rxjs-compat/_esm5/operator/do.js
// module chunks = vendor